// CardCarrito.jsx
import React, { useState, useEffect } from "react";
import trash from "../../assets/trash.svg";
import axios from "axios";


export const getCarrito = async (token) => {
  try {
    const res = await axios.post(
      'https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/conseguir-carrito',
      {
        httpMethod: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, fk_idarea: 4704 }),
        isBase64Encoded: false,
      }
    );
    return JSON.parse(res.data.body);
  } catch (e) {
    console.error(e);
    return [];
  }
};

const CardCarrito = ({ item, dolar, setLoading, onCartChange, setCarrito }) => {
  const token = localStorage.getItem("token");

  const [localCant, setLocalCant] = useState(() => {
    const initialCant = parseInt(item.cantidad, 10);
    return isNaN(initialCant) || initialCant <= 0 ? 1 : initialCant;
  });

  useEffect(() => {
    const updatedCant = parseInt(item.cantidad, 10);
    if (!isNaN(updatedCant) && updatedCant > 0) {
      setLocalCant(updatedCant);
    } else {
      setLocalCant(1);
      updateLocalCart(item.idproducto, "1");
      onCartChange();
      window.dispatchEvent(new Event('cartUpdated'));
    }
  }, [item.cantidad, item.idproducto]);

  const updateLocalCart = (idproducto, cantidad) => {
    const carritoLocal =
      JSON.parse(localStorage.getItem("carrito-sce-product-manager")) || [];
    const itemIndex = carritoLocal.findIndex(
      (prod) => String(prod.idproducto) === String(idproducto)
    );
    if (itemIndex !== -1) {
      carritoLocal[itemIndex].cantidad = String(cantidad);
      if (parseInt(carritoLocal[itemIndex].cantidad, 10) <= 0) {
        carritoLocal.splice(itemIndex, 1);
      }
      localStorage.setItem(
        "carrito-sce-product-manager",
        JSON.stringify(carritoLocal)
      );
    }
  };

  const removeFromLocalCart = (idproducto) => {
    const carritoLocal =
      JSON.parse(localStorage.getItem("carrito-sce-product-manager")) || [];
    const updatedCart = carritoLocal.filter(
      (prod) => String(prod.idproducto) !== String(idproducto)
    );
    localStorage.setItem(
      "carrito-sce-product-manager",
      JSON.stringify(updatedCart)
    );
  };

  const handleCantidad = async (accion, idproducto) => {
    let updatedCant = localCant;
    const cantidadTotal = Number(item.cantidadTotal);

    if (accion === "suma") {
      if (!isNaN(cantidadTotal)) {
        updatedCant = updatedCant < cantidadTotal ? updatedCant + 1 : cantidadTotal;
      } else {
        updatedCant += 1;
      }
    } else if (accion === "resta" && updatedCant > 1) {
      updatedCant -= 1;
    }

    setLocalCant(updatedCant);

    if (token) {
      try {
        await axios.post(
          "https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/cambiar-cantidad",
          {
            httpMethod: "POST",
            headers: { "Content-Type": "application/json" },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ token, idproducto, cantidad: String(updatedCant) }),
            isBase64Encoded: false,
          }
        );
        getCarrito(token).then((arr) => setCarrito(arr));
        onCartChange();
        window.dispatchEvent(new Event('cartUpdated'));
      } catch (error) {
        console.error(error);
      }
    } else {
      updateLocalCart(idproducto, updatedCant);
      onCartChange();
      window.dispatchEvent(new Event('cartUpdated'));
    }
  };

  const handleClick = async (idproducto) => {
    setLoading(false);
    if (token) {
      try {
        await axios.post(
          "https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/borrar-producto-carrito",
          {
            httpMethod: "POST",
            headers: { "Content-Type": "application/json" },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ token, idproducto }),
            isBase64Encoded: false,
          }
        );
        getCarrito(token).then((arr) => setCarrito(arr));
        onCartChange();
        window.dispatchEvent(new Event('cartUpdated'));
      } catch (error) {
        console.error(error);
      }
    } else {
      removeFromLocalCart(idproducto);
      onCartChange();
      window.dispatchEvent(new Event('cartUpdated'));
    }
    setLoading(true);
  };

  const handleChange = async (e, idproducto) => {
    const inputValue = e.target.value;
    let newLocalCant;

    if (!isNaN(inputValue) && parseInt(inputValue, 10) > 0) {
      const parsedValue = parseInt(inputValue, 10);
      newLocalCant =
        parsedValue > item.cantidadTotal ? item.cantidadTotal : parsedValue;
    } else {
      newLocalCant = 1;
    }

    setLocalCant(newLocalCant);

    if (token) {
      try {
        await axios.post(
          "https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/cambiar-cantidad",
          {
            httpMethod: "POST",
            headers: { "Content-Type": "application/json" },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ token, idproducto, cantidad: String(newLocalCant) }),
            isBase64Encoded: false,
          }
        );
        getCarrito(token).then((arr) => setCarrito(arr));
        onCartChange();
        window.dispatchEvent(new Event('cartUpdated'));
      } catch (error) {
        console.error(error);
      }
    } else {
      updateLocalCart(idproducto, newLocalCant);
      onCartChange();
      window.dispatchEvent(new Event('cartUpdated'));
    }
  };

  const itemPriceUSD = item.precio_dolar || 0;
  const itemPriceUSDOffert = item.precio_oferta_dolares || 0;
  const precioConIncremento =
    itemPriceUSDOffert && Number(item.porcentaje_promo) <= 0
      ? itemPriceUSD * dolar
      : item.precio_dolar * dolar;
  const precioConIncrementoOferta = itemPriceUSDOffert * dolar;
  const precioFinal = (precioConIncremento * localCant).toFixed(0);
  let porcentajePromo = Number(item.porcentaje_promo) || 0;
  let cantidadPromo = Number(item.cantidad_promo) || 0;

  let resultado;
  if (porcentajePromo) {
    resultado = precioConIncremento * (1 - porcentajePromo / 100);
  } else if (cantidadPromo) {
    resultado = precioConIncremento - cantidadPromo;
  }

  const calculateInstallment = () => (resultado / 6).toFixed(2);
  const [installmentPrice, installmentDecimal] = calculateInstallment().split(".");

  return (
    <div className="flex py-3 flex-row">
      <img
        src={`https://sistema.depcsuite.com/productos/${item.imagen || item.imageUrl}`}
        alt={item.nombre}
        className="w-24 border"
      />
      <div className="ml-3 w-full">
        <h5 className="font-semibold text-[12px] w-[100%] mb-6 text-left">
          {item.nombre}
        </h5>
        <div className="border w-20 flex items-center justify-between px-2">
          <button
            className="font-semibold h-6 w-6 text-center"
            onClick={() => handleCantidad("resta", item.idproducto)}
            disabled={localCant <= 1}
          >
            -
          </button>
          <input
            type="number"
            onChange={(e) => handleChange(e, item.idproducto)}
            className="h-6 w-10 text-center"
            value={localCant}
            min="1"
          />
          <button
            className="font-semibold h-6 w-6 text-center"
            onClick={() => handleCantidad("suma", item.idproducto)}
            disabled={localCant >= item.cantidadTotal}
          >
            +
          </button>
        </div>
        <div className="flex flex-row text-[12px] justify-between mt-2.5">
          {porcentajePromo !== 0 || cantidadPromo !== 0 ? (
            <div>
              <span className="mr-2 text-[#E40F1B] font-semibold">
                {`${Number(resultado * localCant).toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                  maximumFractionDigits: 0,
                })} Promo HotWeek ${
                  porcentajePromo > 0 ? `${porcentajePromo}%` : ` - ${cantidadPromo}`
                }`}
              </span>
            </div>
          ) : (
            <div>
              <span className="mr-2 text-[#E40F1B] font-semibold">
                {Number(item.precio * localCant || precioConIncremento * localCant).toLocaleString(
                  "es-AR",
                  {
                    style: "currency",
                    currency: "ARS",
                    maximumFractionDigits: 0,
                  }
                )}
              </span>
            </div>
          )}
          <button onClick={() => handleClick(item.idproducto)}>
            <img src={trash} className="w-4" alt="Eliminar" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardCarrito;
